import type { FunctionComponent } from 'react'
import React from 'react'
import { Button, Modal } from '@arvoreeducacao/bonsai-ds'
import { useVoiceControl, getVoiceStrings } from 'context/voice-control'

import * as S from './ModalVoiceHelp.styles'

const ModalVoiceHelp: FunctionComponent = () => {
  const voice = useVoiceControl()

  if (!voice.isHelpOpen) return null

  const strings = getVoiceStrings(voice.locale)

  return (
    <Modal
      title={strings.helpTitle}
      isOpen={true}
      type="standard"
      size="small"
      onClose={voice.closeHelp}
      hasDesktopCloseButton
      titleSize={4}
      center
      sheetHeaderProps={{
        title: strings.helpTitle,
        type: 'close'
      }}
      portalContainer={document.getElementById('modal')}
    >
      <S.Wrapper>
        <S.Intro>{strings.helpIntro}</S.Intro>
        <S.List>
          {strings.commands.map(command => (
            <S.Item key={command.phrase}>
              <S.Phrase>{command.phrase}</S.Phrase>
              <S.Description>{command.description}</S.Description>
            </S.Item>
          ))}
        </S.List>
        <S.Actions>
          <Button
            theme={{ type: 'secondary', size: 'large' }}
            text={strings.helpDisable}
            fluid
            onClick={voice.disable}
          />
          <Button
            theme={{ type: 'primaryLivros', size: 'large' }}
            text={strings.helpClose}
            fluid
            onClick={voice.closeHelp}
          />
        </S.Actions>
      </S.Wrapper>
    </Modal>
  )
}

export default ModalVoiceHelp
